module.exports = __webpack_public_path__ + "img/atention.400b7284.svg";